import React from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import WorkflowModel from '../../../models/WorkflowModel';
import WorkflowTaskEditPricesModel from '../../../models/WorkflowTaskEditPricesModel';
import { Result } from '../../../types/Result';

interface IProps {
    formData: WorkflowTaskEditPricesModel
    onCellChange?: (value: any, rowIndex: number, dataProp?: string) => void
    serverErrors?: Result[]
    workflow: WorkflowModel
}

const TaskEditPricesView: React.FC<IProps> = ({ formData, onCellChange, serverErrors, workflow }) => {

    const businessPartners = useSelectListOptions('api/v1/selectlist/BusinessPartnersForItem?itemId=' + workflow.itemRevision.itemId, '-- Select business-partner');
    const currencies = useSelectListOptions('api/v1/selectlist/CurrencySymbols', '-- Select currency');
    const incoTerms = useSelectListOptions('api/v1/selectlist/IncoTerms', '-- Select incoterms');

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Type', dataProp: 'priceType.name', sort: 'asc', width: 200 },
        { title: 'Volume', dataProp: 'priceTranche', width: 250 },
        { title: 'Currency', dataProp: 'currencyId', editable: true, width: 175, options: currencies },
        { title: 'Price', dataProp: 'amount', align: 'right', dataType: 'decimal', editable: true, width: 200 },
        { title: 'Incoterms', dataProp: 'incoTermId', editable: true, width: 200, options: incoTerms },
        { title: 'Business partner', dataProp: 'businessPartnerId', editable: true, width: 400, options: businessPartners },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date', editable: true },
        { title: 'End date', dataProp: 'endDate', dataType: 'date', editable: true },
        { title: 'Remarks', dataProp: 'remarks', editable: true, width: 200 },
    ];

    if (businessPartners && incoTerms && currencies) {
        return (
            <div style={{ marginBottom: 20 }}>
                <DataTable key='dtWorkflowEditItemPrices'
                    name='dtWorkflowEditItemPrices'
                    colInfos={colInfos}
                    tableData={formData.prices}
                    serverErrors={serverErrors}
                    onCellChange={onCellChange}
                    />
            </div>
        );
    }

    return null;
}
export default TaskEditPricesView;